
<template>
  <a-config-provider :locale="zh_CN">
    <div id="app">
          <!-- 这里是会被缓存的视图组件，比如 Home！ -->
          <router-view></router-view>
    </div>
  </a-config-provider>
</template>

<script>
  import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
  import moment from 'moment';
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');
  export default {
    name: 'App',
    components: {
    },
    data() {
      return {
        zh_CN,
      }
    },
    mounted () {
    }

  }
</script>

<style>
</style>
